import http from "../core/http";
const group = 'vessels';

export const getActivePermitsRequest = async (data) => {
    return await http.post(`${group}/getActivePermits`, data).then(res => res.data).catch(http.defaultCatch);
};
